import $ from 'jquery';

/**
 * Change read-only field to allow editing
 */
class FileUploadPreview {
    constructor () {
        this.$imageField = $('.js-image-upload-field');

        this.$imageField.on('change', FileUploadPreview.previewImage);
    }

    static previewImage () {
        if (this.files && this.files[0]) {
            const reader = new FileReader();
            const self   = this;

            reader.onload = function (e) {
                const $wrapper = $(self).closest('.js-image-upload-field-wrapper');
                const $img     = $wrapper.find('.js-image-upload-field-target').attr('src', e.target.result);
                const $circle  = $img.parent();

                $circle.show();
            };

            reader.readAsDataURL(this.files[0]); // convert to base64 string
        }
    }
}

export default FileUploadPreview;
